import Menu from './layout/menu/Menu';
import OnError from './layout/on-error/OnError';
import NoAuth from './layout/no-auth/NoAuth';
import Logout from './layout/logout/Logout';
import BaseViewComponent from './base/view/base-view';
import StartProgram from './components/programs/StartProgram';
import PharmacyPlanDtl from './layout/custom/PharmacyPlanDtl';
import JavaToPresto from './layout/custom/JavaToPresto';

const routes = [
  {
    path: '/masterMenu',
    component: Menu
  },
  {
    path: '/on-error',
    component: OnError
  },
  {
    path: '/program/**',
    component: StartProgram
  },
  {
    path: '/logout',
    component: Logout
  },
  {
    path: '/no-auth',
    component: NoAuth
  },
  {
    path: '/pn3phnworkfile/rcpn3003dspnetworktocpy',
    component: JavaToPresto
  },
  {
    path: '**',
    component: BaseViewComponent
  }
];

export default routes;
